<template>
  <section v-lenis-scroll class="sounds-of-india-section" :style="bgStyle">
    <div class="sounds-of-india_container">
      <div class="BannerSection">
        <div class="sounds-of-india_banner bannerinnersection">
          <div class="video_container bannervideo">
            <!-- <div class="video_overlay" v-if="showOverlay" @click="togglePlayPause"></div> -->
            <div class="soundsOfIndiaVideo">
              <iframe
                ref="videoElement"
                :src="youtubeEmbedUrl"
                :allow="showControls ? 'autoplay; encrypted-media' : 'encrypted-media'"
                frameborder="0"
                allowfullscreen
                webkit-playsinline="true"
                playsinline="true"
                rel="0"
                modestbranding="1"
                autohide="1"
              />
            </div>
            <!-- <video :key="`video-${shopifyData.sectionId}`" :ref="`videoElement-${shopifyData.sectionId}`"
                            loop muted controlsList="nodownload" disablepictureinpicture webkit-playsinline playsinline
                            preload="auto" autoplay>
                            <source :src="shopifyData.videolink" type="video/mp4" />
                        </video> -->
            <!-- <div class="videoControl"> -->
            <!-- Play/Pause Button -->
            <!-- <span class="pauseIcon" v-if="!isPaused" @click="togglePlayPause">
                                <svg xmlns="http://www.w3.org/2000/svg" width="39" height="46" fill="#6857A1"
                                    class="bi bi-pause" viewBox="0 0 16 16">
                                    <path
                                        d="M6 3.5a.5.5 0 0 1 .5.5v8a.5.5 0 0 1-1 0V4a.5.5 0 0 1 .5-.5m4 0a.5.5 0 0 1 .5.5v8a.5.5 0 0 1-1 0V4a.5.5 0 0 1 .5-.5" />
                                </svg>
                            </span>
                            <span class="playIcon" v-if="isPaused" @click="togglePlayPause">
                                <svg xmlns="http://www.w3.org/2000/svg" class="bi bi-play-fill" width="39" height="46"
                                    viewBox="0 0 39 46" fill="none">
                                    <path d="M39 23L-2.12073e-06 45.5167L-1.52262e-07 0.483338L39 23Z" fill="#6857A1" />
                                </svg>
                            </span> -->

            <!-- </div>
                        <div class="muteUnmute_container"> -->
            <!-- Mute/Unmute Button -->
            <!-- <span class="videoMute" v-if="isMuted" @click="toggleMute">
                                <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="#6857A1"
                                    class="bi bi-volume-mute-fill" viewBox="0 0 16 16">
                                    <path
                                        d="M6.717 3.55A.5.5 0 0 1 7 4v8a.5.5 0 0 1-.812.39L3.825 10.5H1.5A.5.5 0 0 1 1 10V6a.5.5 0 0 1 .5-.5h2.325l2.363-1.89a.5.5 0 0 1 .529-.06m7.137 2.096a.5.5 0 0 1 0 .708L12.207 8l1.647 1.646a.5.5 0 0 1-.708.708L11.5 8.707l-1.646 1.647a.5.5 0 0 1-.708-.708L10.793 8 9.146 6.354a.5.5 0 1 1 .708-.708L11.5 7.293l1.646-1.647a.5.5 0 0 1 .708 0" />
                                </svg>
                            </span>
                            <span class="videoUnMute" v-if="!isMuted" @click="toggleMute">
                                <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="#6857A1"
                                    class="bi bi-volume-up-fill" viewBox="0 0 16 16">
                                    <path
                                        d="M11.536 14.01A8.47 8.47 0 0 0 14.026 8a8.47 8.47 0 0 0-2.49-6.01l-.708.707A7.48 7.48 0 0 1 13.025 8c0 2.071-.84 3.946-2.197 5.303z" />
                                    <path
                                        d="M10.121 12.596A6.48 6.48 0 0 0 12.025 8a6.48 6.48 0 0 0-1.904-4.596l-.707.707A5.48 5.48 0 0 1 11.025 8a5.48 5.48 0 0 1-1.61 3.89z" />
                                    <path
                                        d="M8.707 11.182A4.5 4.5 0 0 0 10.025 8a4.5 4.5 0 0 0-1.318-3.182L8 5.525A3.5 3.5 0 0 1 9.025 8 3.5 3.5 0 0 1 8 10.475zM6.717 3.55A.5.5 0 0 1 7 4v8a.5.5 0 0 1-.812.39L3.825 10.5H1.5A.5.5 0 0 1 1 10V6a.5.5 0 0 1 .5-.5h2.325l2.363-1.89a.5.5 0 0 1 .529-.06" />
                                </svg>
                            </span>
                        </div> -->
          </div>
          <img
            class="bannertext"
            src="https://cdn.shopify.com/s/files/1/0689/7618/1550/files/bannerTextImage.png"
            alt="Banner Text Image"
          />
        </div>
      </div>
      <div class="conversationsection">
        <div class="conversationinnersection">
          <div class="culture_arts">
            <p class="sm_info">ART & CULTURE PERSPECTIVES MUSIC</p>
          </div>
          <div class="in_converstaion">
            <h4 class="in_converstaion_title md_info_title">In Conversation</h4>
            <p class="in_converstaion_title md_info">
              Shivam Punjya, Ankur Tewari, Raja Kumari, & Mohammad Muneem
            </p>
          </div>
          <div class="desktop-view">
            <p class="sm_info">4895 Words</p>
          </div>
          <div>
            <p class="mobile-view sm_info">4895 Words</p>
            <p class="sm_info">18-minute read</p>
          </div>
        </div>
        <div class="conversation_text_section commonimgsection">
          <img
            class="conversation_circle circle_layers"
            src="https://cdn.shopify.com/s/files/1/0689/7618/1550/files/circlePng.png?v=1737452516"
            alt="Conversation Circle Image"
          />
          <div class="conversation_text_section_left commonimgsection">
            <img
              class="circle_mob_left circle_layers"
              src="https://cdn.shopify.com/s/files/1/0689/7618/1550/files/circlePng.png?v=1737452516"
              alt="Circle Image"
            />
            <p class="conversation_heading_section lg_info_title">
              {{ shopifyData.boldText }}
            </p>
            <p v-for="(info, index) in shopifyData.infoData" :key="index" class="lg_info">
              {{ info.info }}
            </p>
            <div class="reimagined_section commonimgsection">
              <img
                class="circle_mob_right circle_layers"
                src="https://cdn.shopify.com/s/files/1/0689/7618/1550/files/circlePng.png?v=1737452516"
                alt="Circle Image"
              />

              <img
                class="imagine_text_mob"
                src="https://cdn.shopify.com/s/files/1/0689/7618/1550/files/mobileIndiaReimagine.png?v=1737452427"
                alt="Mobile India Reimagine Image"
              />
              <p class="lg_info">
                <span class="lg_info_title">First, we have Ankur Tewari,</span> a Brussels-born
                singer, songwriter, music composer, and music supervisor, who is known for his work
                on films such as Slumdog Millionaire, Gully Boy, Gehraiyaan, and more recently, The
                Archies. Ankur is the Creative Architect and producer of Coke Studios Bharat. Ankur
                is also the lead singer of the band The Ghalat Family, known for their “acoustic
                guitar-based poetic ballads with hummable melodies.”
              </p>
            </div>
          </div>
          <div class="conversation_text_section_right">
            <div class="rajkumari_Section">
              <p class="lg_info">
                <span class="lg_info_title">We then move into conversation with Raja Kumari,</span>
                a multi-hyphenate, Indian-American rapper, singer, and songwriter. She is known for
                fusing classical Indian music with hip-hop, and more recently, pop. Raja Kumari is a
                Grammy-nominated artist and trained Indian classical dancer. Raja Kumari has
                collaborated with John Legend, Madhuri Dixit, A.R. Rahman, Sidhu Moosewala, and Guru
                Randhawa, among others, released solo work, and serves as a cultural bridge between
                the East and West.
              </p>
              <p class="lg_info">
                <span class="lg_info_title">Lastly, we our conversation with Mohammad Muneem,</span>
                a Kashmiri singer, songwriter, and poet, who performs in Kashmiri, Urdu, and Hindi.
                He is the founder of the band Alif. Mohammad blends Kashmiri traditional and folk
                styles with contemporary Western genres, addressing themes of identity, struggle,
                and spirituality. He has won awards at the Dada Saheb Phalke Film Festival and the
                Indian Independent Music Awards. Mohammad also teaches songwriting and Urdu poetry.
              </p>
            </div>
          </div>
        </div>
        <div class="limited_edition_parent commonimgsection">
          <img
            class="layer_circle_left circle_layers"
            src="https://cdn.shopify.com/s/files/1/0689/7618/1550/files/circlePng.png"
            alt="Circle Image"
          />
          <div class="commonimgsection layer_circle_right">
            <img
              class="circle_layers"
              src="https://cdn.shopify.com/s/files/1/0689/7618/1550/files/circlePng.png"
              alt="Circle Image"
            />
          </div>
          <div class="limited_edition_left">
            <img
              class="imagine_text_web"
              src="https://cdn.shopify.com/s/files/1/0689/7618/1550/files/desktopIndiaReimagined.png"
              alt="Desktop India Reimagined Image"
            />
          </div>

          <div class="limited_edition_right">
            <div class="limited_edition">
              <h3 class="limited_editon_text">READ MORE & GET YOUR</h3>
              <h2 class="limited_edition_name">LIMITED EDITION</h2>
              <h3 class="limited_editon_text">BEHNO NEW YORK ZINE</h3>
              <a :href="shopifyData.btnLink" class="limited_edition_btn">{{
                shopifyData.btnTitle
              }}</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
/* global YT */
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
export default {
  props: {
    shopifyData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      // isPaused: false, // State for video playback
      // isMuted: true, // State for audio
      // showOverlay: true,
      showControls: false,
      player: null,
    };
  },
  computed: {
    youtubeEmbedUrl() {
      const youtubeLink = this.shopifyData.videolink;
      // const youtubeLink = "https://www.youtube.com/embed/OH05_Sko0Yo?si=JhnlpEUMX8paZAO6";
      const videoIdMatch = youtubeLink.match(
        /(?:https?:\/\/)?(?:www\.)?youtube\.com\/watch\?v=([^&]+)|youtu\.be\/([^&]+)/
      );
      const videoId = videoIdMatch ? videoIdMatch[1] || videoIdMatch[2] : null;
      if (videoId) {
        return `https://www.youtube.com/embed/${videoId}?enablejsapi=1`;
      }
      return youtubeLink;
    },
    bgStyle() {
      return {
        background: this.shopifyData?.bgColor || 'transparent',
      };
    },
  },
  mounted() {
    gsap.registerPlugin(ScrollTrigger); // Register GSAP plugin once
    this.setupGSAPAnimations();
    this.loadYouTubeAPI();
    this.observeVideo();
  },
  beforeUnmount() {
    if (this.player) {
      this.player.destroy();
    }
  },
  methods: {
    onPlayerReady(event) {
      this.player = event.target;
      this.showControls = true;
    },
    loadYouTubeAPI() {
      if (!window.YT) {
        const tag = document.createElement('script');
        tag.src = 'https://www.youtube.com/iframe_api';
        const firstScriptTag = document.getElementsByTagName('script')[0];
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
        window.onYouTubeIframeAPIReady = this.createPlayer;
      } else {
        this.createPlayer();
      }
    },
    createPlayer() {
      if (!window.YT) {
        console.error('YouTube API not loaded yet.');
        return;
      }
      this.player = new YT.Player(this.$refs.videoElement, {
        events: {
          onReady: this.onPlayerReady,
        },
      });
      // console.log('Player instance created:', this.player);
    },
    observeVideo() {
      const options = {
        root: null,
        rootMargin: '0px',
        threshold: 0.5,
      };

      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            if (this.player) {
              // console.log('Video is in viewport');
            } else {
              // console.warn('Player is not ready yet');
            }
            observer.unobserve(entry.target);
          }
        });
      }, options);

      observer.observe(this.$refs.videoElement);
    },

    // togglePlayPause() {
    //     // Play or pause the video
    //     const video = this.getVideoElement();
    //     if (!video) return;

    //     if (this.isPaused) {
    //         video.play().then(() => {
    //             this.isPaused = false;
    //             this.showOverlay = true;
    //         }).catch(error => {
    //             console.error("Video play failed:", error);
    //         });
    //     } else {
    //         video.pause();
    //         this.isPaused = true;
    //         this.showOverlay = true;
    //     }
    // },
    // toggleMute() {
    //     // Mute or unmute the video
    //     const video = this.getVideoElement();
    //     if (!video) return;

    //     this.isMuted = !this.isMuted;
    //     video.muted = this.isMuted;
    // },
    // getVideoElement() {
    //     // Get video element reference safely
    //     const refKey = `videoElement-${this.shopifyData.sectionId}`;
    //     return this.$refs[refKey] || null;
    // },
    // initVideo() {
    //     // Initialize the video element on mount
    //     const video = this.getVideoElement();
    //     if (video) {
    //         video.muted = this.isMuted;
    //         video.play().catch(error => {
    //             console.warn("Autoplay might not be allowed:", error);
    //         });
    //     } else {
    //         console.error(`Video element not found for section: ${this.shopifyData.sectionId}`);
    //     }
    // },

    setupGSAPAnimations() {
      // Banner Section Animation
      gsap
        .timeline({
          scrollTrigger: {
            trigger: '.BannerSection',
            start: '0% 0%',
            scrub: true,
          },
        })
        .to('.bannertext', {
          rotation: 90,
          duration: 2.5,
        });

      // Image Section Animations
      const sections = this.$el.querySelectorAll('.commonimgsection');
      sections.forEach((section) => {
        const sectionImage = section.querySelector('img');
        if (sectionImage) {
          gsap
            .timeline({
              scrollTrigger: {
                trigger: section,
                start: '0% 80%',
                scrub: 3,
              },
            })
            .fromTo(
              sectionImage,
              { rotation: 0, scale: 0.9, ease: 'expo.out' },
              { rotation: 360, scale: 1, duration: 2.5, ease: 'expo.out' }
            );
        }
      });
    },
  },
};
</script>

<style scoped>
.soundsOfIndiaVideo {
  max-width: 823px;
  height: 423px;
  width: 100%;
}
.soundsOfIndiaVideo iframe {
  width: 100%;
  height: 100%;
}
.soundsOfIndiaVideo .ytp-expand-pause-overlay .ytp-pause-overlay {
  display: none !important;
}
.ytp-pause-overlay-container {
  display: none;
}
.soundsOfIndiaVideo .ytp-title-text {
  display: none !important;
}
.soundsOfIndiaVideo .ytp-right-controls {
  display: none !important;
}
.ytp-pause-overlay {
  display: none !important;
}

.sounds-of-india-section {
  overflow: hidden;
}

.sounds-of-india_container {
  max-width: 1376px;
  width: 100%;
  padding: 0 24px;
  margin: 0 auto;
}

.video_container {
  position: relative;
}
.pauseIcon {
  display: none;
}

.videoControl {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 4;
}

.playIcon svg {
  width: 23px;
  display: block;
  display: none;
}

.lg_info_title {
  font-family: 'Neue Haas Grotesk Display Pro', sans-serif;
  font-size: 21px;
  font-weight: 600;
  line-height: 120%;
  color: #ffffff;
}

.lg_info {
  font-family: 'Neue Haas Grotesk Display Pro', sans-serif;
  font-size: 21px;
  font-weight: 300;
  line-height: 120%;
  color: #ffffff;
  margin-bottom: 20px;
}

.sm_info {
  font-family: 'Cartograph CF', sans-serif;
  font-size: 12px;
  font-weight: 300;
  line-height: 148%;
  color: #ffffff;
}

.md_info {
  font-family: 'PP Editorial New', sans-serif;
  font-size: 15px;
  font-style: italic;
  font-weight: 200;
  line-height: 128%;
  color: #ffffff;
}

.md_info_title {
  font-family: 'PP Editorial New', sans-serif;
  font-size: 15px;
  font-weight: 700;
  line-height: 120%;
  color: #ffffff;
}

.bannerinnersection {
  padding: 125px 0 21px 0;
  position: relative;
}

.bannertext {
  position: absolute;
  top: 69px;
  right: 0;
  max-width: 630px;
  width: 100%;
}

.bannervideo {
  max-width: 823px;
  width: 100%;
}

.conversationinnersection {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 38px 0 0 0;
}

.culture_arts {
  max-width: 96px;
}

.in_converstaion {
  max-width: 140px;
}

.in_converstaion_title {
  text-align: center;
}

.conversation_text_section {
  padding: 80px 0 0 0;
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  position: relative;
  gap: 20px;
}

.conversation_text_section_right,
.conversation_text_section_left {
  max-width: 597px;
  position: relative;
}

.circle_mob_left {
  position: absolute;
  display: none;
}

.circle_mob_right {
  position: absolute;
  display: none;
}

.conversation_text_section_right {
  margin-top: 105px;
}

.reimagined_section {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 81px;
  position: relative;
  margin-top: 43px;
}

.conversation_middle_text {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 30px;
  margin: 91px 0 44px 0;
}

.rajkumari_Section {
  display: flex;
  flex-direction: column;
  gap: 30px;
}

.conversation_heading_section {
  max-width: 527px;
  text-indent: 40%;
  text-align: start;
  margin-bottom: 94px;
}

.limited_edition {
  border: 1px solid #e9aa2c;
  padding: 16px 0 20px 0;
  border-radius: 20px;
  max-width: 424px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #e9aa2c;
}

.limited_edition_btn {
  background-color: #e9aa2c;
  padding: 20px 18px;
  border-radius: 20px;
  max-width: 280px;
  width: 100%;
  outline: none;
  border: none;
  cursor: pointer;
  margin-top: 20px;
  text-align: center;
  font-family: 'Neue Haas Grotesk Display Pro', sans-serif;
  font-size: 15px;
  font-weight: 600;
  line-height: 91%;
  color: #ffffff;
}

.limited_edition_name {
  padding: 8px 0;
  color: #e9aa2c;
  font-weight: 200;
  font-style: italic;
  font-size: 36px;
  line-height: 91%;
}

.limited_editon_text {
  color: #e9aa2c;
  font-size: 13px;
  font-weight: 700;
  line-height: 91%;
}

.edition_parent {
  display: flex;
  justify-content: center;
  align-items: center;
}

.limited_edition_parent {
  display: grid;
  grid-template-columns: 1fr 1fr;
  align-items: center;
  padding: 81px 0;
  position: relative;
}

.limited_edition_right {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.limited_edition_left {
  display: flex;
  align-items: center;
  justify-content: center;
}

.conversation_circle {
  position: absolute;
  right: -20%;
  top: -24%;
}

.layer_circle_left {
  position: absolute;
  left: -30%;
  top: -50%;
}

.layer_circle_right {
  position: absolute;
  right: -30%;
  bottom: -62%;
}

.imagine_text_mob {
  display: none;
}

.mobile-view {
  display: none;
  text-align: right;
}
.imagine_text_web {
  max-width: 338px;
}

@media screen and (max-width: 1024px) {
  .circle_layers {
    max-width: 600px;
    width: 100%;
  }

  .conversation_circle {
    top: -10%;
    right: -35%;
  }
}

@media screen and (max-width: 768px) {
  .bannertext {
    top: 40px;
  }

  .lg_info_title {
    font-size: 18px;
  }

  .lg_info {
    font-size: 18px;
  }

  .sm_info {
    font-size: 10px;
  }

  .md_info {
    font-size: 13px;
  }

  .md_info_title {
    font-size: 13px;
  }

  .conversation_text_section {
    flex-direction: column;
    align-items: center;
    gap: 0;
    padding: 40px 0 0 0;
  }

  .limited_edition_parent {
    grid-template-columns: 1fr;
    padding: 78px 0 67px 0;
  }

  .limited_edition_right {
    justify-content: center;
  }

  .limited_edition_left {
    display: none;
  }

  .imagine_text_mob {
    display: block;
    max-width: 338px;
    width: 100%;
  }

  .conversation_middle_text {
    margin: 50px 0 44px 0;
  }

  .conversation_text_section_right {
    margin-top: 0;
  }

  .rajkumari_Section {
    gap: 20px;
    padding-top: 36px;
    align-items: center;
  }

  .circle_layers {
    max-width: 397px;
    width: 100%;
  }

  .reimagined_section {
    gap: 42px;
  }
  .conversation_heading_section {
    margin-bottom: 24px;
  }
}

@media screen and (max-width: 550px) {
  .conversation_circle {
    top: -1%;
    right: -35%;
  }

  .layer_circle_left {
    left: -70%;
  }

  .layer_circle_right {
    bottom: -75%;
    right: -50%;
  }

  .circle_mob_left {
    display: block;
    top: 35%;
    left: -35%;
  }

  .circle_mob_right {
    display: block;
    top: 25%;
    right: -30%;
  }

  .culture_arts {
    max-width: 64px;
  }
}

@media screen and (max-width: 425px) {
  .bannerinnersection {
    padding-top: 100px;
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 323px;
  }

  .bannervideo {
    max-width: 267px;
  }

  .lg_info_title {
    font-size: 15px;
  }

  .lg_info {
    font-size: 15px;
  }

  .sm_info {
    font-size: 8px;
  }

  .md_info {
    font-size: 12px;
  }

  .md_info_title {
    font-size: 12px;
  }

  .conversation_text_section {
    padding: 20px 0 0 0;
  }

  .conversation_middle_text {
    margin: 26px 0 44px 0;
    gap: 20px;
  }

  .imagine_text_mob {
    max-width: 162px;
  }

  .desktop-view {
    display: none;
  }

  .mobile-view {
    display: block;
  }

  .limited_edition {
    max-width: 264px;
  }

  .limited_edition_name {
    font-size: 20px;
  }

  .limited_editon_text {
    font-size: 10px;
  }

  .limited_edition_btn {
    padding: 12px;
    font-size: 10px;
    max-width: 175px;
    width: 100%;
    margin-top: 16px;
  }
}
</style>
